<template>
  <WeContainer header="true" v-bind:actions="actions">
    <WeTable
      v-bind:index="false"
      v-bind:data="coupon.list"
      v-bind:columns="columns"
      v-bind:actions="tableActions"
      v-on:on-action="onAction"
      v-on:on-switch="onSwitch"
      v-bind:allow-sort-index="false"
      v-bind:ajax="true"
      v-bind:loading="loading"
      v-bind:table-result="tableResult"
      v-on:make-request="updateCouponList"
    ></WeTable>
  </WeContainer>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "List",
  data() {
    return {
      loading: false,
      list: [],
      actions: [
        {
          text: "Yeni Kupon",
          path: "coupons/new",
        },
        {
          text: "Çöp Kutusu",
          class: "btn btn-outline-danger float-md-right",
          icon: "fas fa-trash",
          path: "coupons/trash",
        },
      ],
      tableActions: [
        {
          icon: "fas fa-edit",
          class: "btn-outline-primary",
          action: "edit",
        },
        {
          icon: "fas fa-trash",
          class: "btn-outline-danger ml-2",
          action: "remove",
        },
      ],
      columns: [
        { name: "code", th: "Kupon Kodu", type: "string" },
        { name: "name", th: "Kupon Açıklaması", type: "string" },        
        { name: "discount_amount", th: "İndirim Miktarı", type: "string" },
        { name: "created_by", th: "Oluşturan Kişi", type: "string" },
        { name: "created_at", th: "Oluşturma Tarihi", type: "date" },
        { name: "is_active", th: "Durum", type: "boolean" },
      ],
      tableResult: {
        item_count: 1,
        current_page: 1,
        total_page: 1,
        total_items: 1,
      },
    };
  },
  methods: {
    ...mapActions("coupon", ["getList", "delete", "isActive"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onDelete(data.row, data.index);
      } else if (data.key == "edit") {
        this.onEdit(data.row);
      }
    },
    onEdit(row) {
      this.$router.replace("coupons/detail/" + row.id);
    },
    onDelete(row) {
      let message = `${row.name} adlı kupon kodunu silmek istediğinize emin misiniz ?`;

      this.$swal({
        title: message,
        html: `Bu işlemi <b class="text-danger">Çöp Kutusu</b> bölümünden geri alabilirsiniz.`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          this.delete({
            id: row.id,
            onSuccess: (result) => {
              if (result && result.data && result.data.status !== "error") {
                this.$toast.success("Kupon Kodu Başarıyla Silindi");
                this.removeFromList(row.id);
              } else {
                this.$swal({
                  title: "Kupon Kodu Silinemedi",
                  text: result.data.message,
                  icon: "error",
                  confirmButtonText: "Tamam",
                });
              }
            },
          });
        }
      });
    },
    onSwitch(data) {
      this.isActive({
        form: data,
        onSuccess: (result) => {
          if (result && result.data && result.data.status !== "error") {
            this.$toast.success("Durum Güncellendi");
          } else {
            this.$toast.error("Durum Güncellenemedi");
          }
        },
        onError: (error) => {
          this.$toast.error("Durum Güncellenemedi");
        },
      });
    },
    removeFromList(id) {
      const index = helper.arrayFind(this.coupon.list, "id", id);
      if (index >= 0) {
        this.coupon.list.splice(index, 1);
      }
    },
    updateCouponList(requestData = null) {
      this.loading = true;
      requestData = requestData || {
        page: 1,
        limit: 25,
      };

      this.getList({
        table: requestData,
        onSuccess: (result) => {
          helper.copy(result.data, this.tableResult, ["items", "status"]);
        },
        onFinish: () => {
          this.loading = false;
        },
      });
    },
  },
  computed: {
    ...mapState(["coupon", "shared"]),
  },
};
</script>
